import React, { useState } from "react";
import { postReq ,patchReq} from "../middleware/AxiosApisCall";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg"; //1
import TableData from "../Partials/TableData3"; //2
import DataList from "../Partials/DataList";
import { useNavigate } from "react-router-dom";
// import SelectDataList from "../Partials/SelectDataList";
export const Areamanage = () => {
  const navigate=useNavigate();
  const path = "Area";
  const [inputs, setInputs] = useState({});
  const [tableRefresh, setTableRefresh] = useState(0); //3
  const[par, setPar] = useState()
// const [selected,setSelected]=useState();
  // This function is used to set Input fields
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // In this function  used to add and edit the Area details
  const handleSubmit = async (event) => {
    event.preventDefault();
    if(par){
      // This API request is used to edit the particular AREA.
      const response = await patchReq(path, inputs,par);
      if (response.success) {
        setPar()
        setTableRefresh(tableRefresh+1);//4
        setInputs({});//5
        SuccessAlert({title: "Edit Area", message: "Area Update successfully" });
      } else {
        setPar();
        setTableRefresh(tableRefresh + 1); //4
        setInputs({});
        ErrorAlert({title: "Edit Area",message: response.msg});
      }

    }else {
    // This API is used to Post new AREA into data base.
      const response = await postReq(path, inputs);
      if (response.success) {
        setTableRefresh(tableRefresh + 1); //4
        setInputs({}); //5
        SuccessAlert({ title: "Add Area", message: "Area Added successfully" });
      } else {
       
        ErrorAlert({ title: "Add Area", message: response.msg});
      }

    }

  }

  // This function is used to get Id on click
  const editClick=(pid)=>{
    setPar(pid._id)
    setInputs(pid) 
}


// const handleSelected=(value)=>{
//   setSelected(value)
//   setInputs((values) => ({ ...values, city:value.label }));
// }
// console.log('selected:',selected);
  return (
    <React.Fragment>
      <div className="add-user-container">
        <div className="headingdiv">
          <span className="componet-title">Area Manage</span>
          <div>
          <button onClick={(()=>navigate(-1))}>Back</button>
          </div>
        </div>
        <div className="option-btn">
          <button
            onClick={() => {
              navigate("../unitmanage");
            }}
          >
         Unit Manage
          </button>
        </div>
        <form className="flex-row form-2col-ver" onSubmit={handleSubmit}>
          <div className="componet-sub-title">
          <span>{par?(<span>Edit </span>):(<span>Add </span>)}Area </span>
          </div>

          <div className="flex-row">
          <div className="input-lable-h-div">
            <label htmlFor="area">Area:</label>
            <input
              name="area"
              type="text"
              value={inputs.area || ""}
              onChange={handleChange}
              required
            />
            </div>
            </div>
            
             <div className="flex-row">
          <div className="input-lable-h-div">
         <DataList
            value={inputs.city || ""}
              path={"City"}
              handleChange={handleChange}
              option={"city"}
              name={"city"}
              heading={"City"}
            /> 
      </div>
      </div>
      <div className="flex-row">
          <div className="input-lable-h-div">
            <label></label>
            <button className="submit-btn">{par?(<span>Update </span>):(<span>Add </span>)}</button>
         </div>
         </div>
        </form>

        <TableData path={path} key={tableRefresh} editClick={editClick} />
      </div>
    </React.Fragment>
  );
}

